import { render, staticRenderFns } from "./addDomainBatch.vue?vue&type=template&id=3e8b3428&lang=pug"
import script from "./addDomainBatch.vue?vue&type=script&lang=js"
export * from "./addDomainBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports